// Route table. The auth guard + layout shell wrap everything except /login.

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AuthGuard } from "./auth/AuthGuard";
import { Layout } from "./components/Layout";
import { Login } from "./components/Login";
import { Enroll } from "./views/Enroll";
import { Navigator } from "./views/Navigator";
import { Settings } from "./views/Settings";
import { Statistics } from "./views/Statistics";
// YouTube mode (experimental, removable): own shell, sibling of the cinematic layout.
import { YoutubeLayout } from "./youtube/YoutubeLayout";
import { YoutubeNavigator } from "./youtube/YoutubeNavigator";
import { YoutubeStatistics } from "./youtube/YoutubeStatistics";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* Public: single-use authenticator enrollment links. */}
        <Route path="/enroll/:token" element={<Enroll />} />
        <Route
          element={
            <AuthGuard>
              <Layout />
            </AuthGuard>
          }
        >
          <Route path="/" element={<Navigator />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/stats" element={<Statistics />} />
        </Route>
        <Route
          element={
            <AuthGuard>
              <YoutubeLayout />
            </AuthGuard>
          }
        >
          <Route path="/youtube" element={<YoutubeNavigator />} />
          <Route path="/youtube/stats" element={<YoutubeStatistics />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
